import React, { useState, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"

import { Idea } from "../../../../../model/types"
import { useNana } from "../../../../hooks/useNana"
import IdeaBox from "../../../../components/idea_box"
import { NavigationHistoryState } from "../../mosaic"

const Connections = ({ idea }: { idea: Idea }) => {
  const [inverseConnections, setInverseConnections] = useState<Idea[]>([])
  const { model, hub } = useNana()

  useEffect(() => {
    const k2 = hub.on("model:idea-connections-changed", (_) =>
      refreshConnections()
    )

    refreshConnections()

    return () => {
      hub.remove(k2)
    }
  }, [idea])

  const refreshConnections = () => {
    if (idea == null) return
    setInverseConnections(
      model
        .inverseConnections(idea.id)
        .map((id) => model.getIdea(id))
        .filter((idea) => idea != null) as Idea[]
    )
  }

  const jumpToIdea = (idea: Idea): void => {
    NavigationHistoryState.set_open_location(idea.location)
  }

  if (inverseConnections.length === 0) return null

  return (
    <div className="flex max-h-32 shrink-0 flex-col overflow-y-auto border-t border-stone-200/80 dark:border-white/10 md:max-h-44">
      <div className="px-5 pb-1 pt-2.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-stone-400 dark:text-stone-500 md:px-7">
        Linked from
      </div>
      <div className="flex flex-col pb-2">
        {inverseConnections.map((back_connection) => (
          <button
            type="button"
            key={`back_connection_${back_connection.id}`}
            onClick={() => jumpToIdea(back_connection)}
            className="group flex w-full flex-row items-center gap-2.5 px-5 py-1.5 text-left text-sm text-stone-700 transition-colors hover:bg-stone-900/[0.04] focus:outline-none focus-visible:bg-stone-900/[0.04] dark:text-stone-300 dark:hover:bg-white/[0.05] md:px-7"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="h-2.5 w-2.5 shrink-0 text-stone-300 transition-colors group-hover:text-stone-500 dark:text-stone-600 dark:group-hover:text-stone-400"
            />
            <IdeaBox idea={back_connection} shadow={false} />
            <div className="min-w-0 truncate">{back_connection.title}</div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default Connections
